export default __webpack_public_path__ + "static/media/img41.cf655170.jpg";